// eslint-disable-next-line import/no-unresolved
class Lightswitch extends HTMLElement {
  constructor () {
    super()

    this.lightOn = true

    this.toggleEl = this.querySelector('[data-el="lightswitch.toggle"]')

    if (this.toggleEl) {
      this.toggleEl.addEventListener('click', this.toggleLightswitch.bind(this))
    }
  }

  toggleLightswitch (event) {
    event.preventDefault()

    this.lightOn = !this.lightOn

    this.classList.toggle('sec-Lightswitch-off', !this.lightOn)
  }
}

customElements.define('light-switch', Lightswitch)
